// Raw `?preview=1` URL check. This is intentionally read in exactly one
// place -- AuthContext.js, once, at session establishment -- and captured
// into React state (`previewMode` on the auth context) from there. Do not
// call this directly from components: window.location.search is mutable,
// and ordinary in-app navigation (e.g. UserDashboardEnhanced's
// navigateToSection) rewrites the URL without the query string, so any
// component that re-derives preview mode from the live URL will flip back
// to `false` the moment the visitor clicks anywhere. Read `previewMode`
// from `useAuth()` instead.
export const isPreviewMode = () =>
  typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('preview') === '1';
